export default "__VITE_ASSET__98571ae0__"